import { jsx as _jsx } from "react/jsx-runtime";
import BasePlayerButton from "./BasePlayerButton";
const FavoriteButton = ({ isFavorite, onClick }) => {
    const label = isFavorite ? "Desfavoritar" : "Favoritar";
    const iconName = isFavorite ? "star-off" : "star";
    return _jsx(BasePlayerButton, { label: label, iconName: iconName, onClick: onClick });
};
FavoriteButton.displayName = "FavoriteButton";
export default FavoriteButton;
